import { render, staticRenderFns } from "./FunctionRoom.vue?vue&type=template&id=4b5939ad&scoped=true&"
import script from "./FunctionRoom.vue?vue&type=script&lang=js&"
export * from "./FunctionRoom.vue?vue&type=script&lang=js&"
import style0 from "./FunctionRoom.vue?vue&type=style&index=0&id=4b5939ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5939ad",
  null
  
)

export default component.exports